import { AddressApiModel } from 'app/components/map/map.models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MwHttpService } from '@core/http';
import { MwLoadOptionsService } from './utils/load-options.service';
import { MwLoadOptions } from 'app/models/load-options.model';
import { map } from 'rxjs/operators';
import { MwPayloadModel } from 'app/models/payload.model';

@Injectable({ providedIn: 'root' })
export class AddressesApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  get(
    requestModel?: MwLoadOptions
  ): Observable<MwPayloadModel<AddressApiModel[]>> {
    let query = requestModel
      ? this.loadOptionsService.buildQuery(requestModel)
      : '';
    query = query.length > 0 ? '?' + query : query;

    return this.http.authGet<MwPayloadModel<AddressApiModel[]>>(
      `/transport/v1/Companies/{companyId}/Adresses${query}`
    );
  }

  load(addressId: number): Observable<AddressApiModel> {
    const query = this.loadOptionsService.buildQuery(
      new MwLoadOptions({
        filter: ['addressId', '=', addressId],
        numericParameters: { addressId: true },
      })
    );

    return this.http
      .authGet<AddressApiModel[]>(
        `/transport/v1/Companies/{companyId}/Adresses?${query}`
      )
      .pipe(map((addresses) => addresses[0]));
  }

  create(address: AddressApiModel): Observable<AddressApiModel> {
    return this.http.authPost<AddressApiModel>(
      `/transport/v1/Companies/{companyId}/Adresses`,
      {
        body: address,
      }
    );
  }

  update(address: AddressApiModel): Observable<AddressApiModel> {
    return this.http.authPut<AddressApiModel>(
      `/transport/v1/Companies/{companyId}/Adresses`,
      {
        body: address,
      }
    );
  }

  delete(address: AddressApiModel): Observable<AddressApiModel> {
    return this.http.authDelete<AddressApiModel>(
      `/transport/v1/Companies/{companyId}/Adresses`,
      {
        body: address,
      }
    );
  }
}
